import { useEffect, useMemo, useState } from 'react';
import { navItems } from '@/mocks/home';
import { useScrollSpy } from '@/hooks/useScrollSpy';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const ids = useMemo(() => navItems.map((item) => item.id), []);
  const activeId = useScrollSpy(ids);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? 'border-b border-background-200/70 bg-background-50/95 backdrop-blur'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex h-16 w-full items-center justify-between px-4 md:h-[72px] md:px-8" aria-label="主导航">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-water-flash-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold text-foreground-950">17.cc 吃瓜攻略</span>
            <span className="font-label text-[10px] tracking-widest text-foreground-500">GUAGUIDE</span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => {
            const active = activeId === item.id;
            return (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  className={`whitespace-nowrap rounded-md px-3 py-2 font-label text-sm transition-colors ${
                    active
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-950'
                  }`}
                >
                  {item.label}
                </a>
              </li>
            );
          })}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#steps"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            看四步攻略
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            aria-label="展开导航菜单"
            aria-expanded={menuOpen}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {menuOpen ? (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <ul className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  onClick={() => setMenuOpen(false)}
                  className={`flex items-center gap-2 rounded-md px-3 py-2.5 font-label text-sm ${
                    activeId === item.id
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-100 text-foreground-700'
                  }`}
                >
                  <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#steps"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 font-label text-sm font-medium text-background-50"
          >
            <i className="ri-route-line text-base" aria-hidden="true"></i>
            立即查看四步攻略
          </a>
        </div>
      ) : null}
    </header>
  );
}